import getScrollbarSize from "dom-helpers/scrollbarSize";
import { useRouter } from "next/router";
import React, { createContext, PropsWithChildren, useCallback, useEffect, useState } from "react";

type ActiveDetails = null | "notification";

// tslint:disable:no-empty
const initial = {
  isShown: false,
  toggle: () => { },
  show: () => { },
  hide: () => { },
  zIndex: {
    overlay: 10,
    sidemenu: 11,
  },
  activeDetails: null as ActiveDetails,
  openAndShowDetails: (_activeDetails: ActiveDetails) => { },
};
// tslint:enable:no-empty
export const SideMenuContext = createContext(initial);

export const SideMenuProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [sidemenu, setSidemenu] = useState(initial);
  const router = useRouter();

  const hideScrollbar = () => {
    const scrollbar = getScrollbarSize();
    document.body.style.overflow = "hidden";
    if (scrollbar != null && scrollbar > 0) {
      document.body.style.paddingRight = `${scrollbar}px`;
    }
  };

  const show = useCallback(() => {
    setSidemenu({ ...sidemenu, isShown: true });
    hideScrollbar();
  }, [sidemenu]);

  const hide = useCallback(() => {
    setSidemenu(initial);
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }, [sidemenu]);

  const toggle = useCallback(() => {
    if (sidemenu.isShown) {
      hide();
    }
    else {
      show();
    }
  }, [sidemenu]);

  const openAndShowDetails = useCallback((activeDetails: ActiveDetails) => {
    setSidemenu({ ...sidemenu, activeDetails, isShown: true });
    hideScrollbar();
  }, []);

  useEffect(() => {
    hide();
  }, [router.asPath]);

  const context = {
    ...sidemenu,
    toggle,
    show,
    hide,
    openAndShowDetails,
  };

  return (
    <SideMenuContext.Provider value={context}>
      {children}
    </SideMenuContext.Provider>
  );
}
